import React from 'react';
import useImageCache from '../hooks/useImageCache';

function CachedImage({ src, alt, className, preloadSources = [], ...props }) {
  const { isLoaded, isLoading, error } = useImageCache(src, preloadSources);

  if (error) {
    return (
      <div className={`${className} image-error`} {...props}>
        <span>Failed to load image</span>
      </div>
    );
  }

  if (isLoading || !isLoaded) {
    return (
      <div className={`${className} image-loading`} {...props}>
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      {...props}
      style={{
        ...props.style,
        opacity: isLoaded ? 1 : 0,
        transition: 'opacity 0.2s ease'
      }}
    />
  );
}

export default CachedImage;
